import { render, staticRenderFns } from "./ChooseGroup.vue?vue&type=template&id=39b866c4&scoped=true&"
import script from "./ChooseGroup.vue?vue&type=script&lang=js&"
export * from "./ChooseGroup.vue?vue&type=script&lang=js&"
import style0 from "./ChooseGroup.vue?vue&type=style&index=0&id=39b866c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b866c4",
  null
  
)

export default component.exports